import { useState } from "react";

import { useDebounce } from "hooks";

import { CPTCode, useGetCPTCodesQuery } from "services/cpt-codes";

type UseCPTCodeSearchResult = {
  options: CPTCode[];
  isLoading: boolean;
  search: string;
  setSearch: (value: string) => void;
};

export function useCPTCodeSearch(initialSearch = ""): UseCPTCodeSearchResult {
  const [search, setSearch] = useState(initialSearch);
  const { value: dSearch } = useDebounce(search);
  // Skip the request until the user types something. Avoids a wasted full-list
  // fetch on every form mount (the primary + additional fields would otherwise
  // each trigger one).
  const { data: options = [], isLoading } = useGetCPTCodesQuery(dSearch, {
    skip: !dSearch
  });

  return { options, isLoading, search, setSearch };
}
